import { createSelector } from 'reselect';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { type StoreState } from '../types/StoreState';
import { type GooglePayPaymentMethod } from '../types/PaymentMethods';
import { selectTopProps } from './topProps';

export const selectGooglePayDto = (store: StoreState): GooglePayPaymentMethod | undefined => {
  return store.domain.paymentMethods.find(
    (paymentMethod) => !!paymentMethod[PaymentMethod.GooglePay],
  ) as GooglePayPaymentMethod;
};

export const selectGooglePayBtnColor = createSelector(selectTopProps, (topProps) => {
  return topProps.theme === 'light' ? ('white' as const) : ('black' as const);
});

export const selectGooglePayCountryCode = createSelector(
  selectGooglePayDto,
  (paymentMethod): string => paymentMethod && paymentMethod[PaymentMethod.GooglePay].merchantCountry,
);

export const selectGooglePaySupportedNetworks = createSelector(
  selectGooglePayDto,
  (paymentMethod) => paymentMethod && paymentMethod[PaymentMethod.GooglePay].allowCardNetworks,
);

export const selectGooglePayOptions = (store: StoreState) => {
  return store.googlePay.options;
};

export const selectGooglePayButton = (store: StoreState) => {
  return store.googlePay.button;
};

export const selectGooglePayPaymentData = (store: StoreState) => {
  return store.googlePay.paymentData;
};

export const selectGooglePayButtonAvailable = createSelector(
  selectGooglePayDto,
  selectTopProps,
  selectGooglePayOptions,
  (paymentMethod, topProps, options) => {
    if (!topProps.allowPaymentMethods.includes(PaymentMethod.GooglePay)) {
      return false;
    }

    if (!paymentMethod) {
      return false;
    }

    if (topProps.demoMode) {
      return true;
    }

    if (Number(topProps.paymentAmount) < 1) {
      // WixPayments min transaction is amount 1$
      return false;
    }

    return options.loading !== 'rejected';
  },
);
